export default "__VITE_ASSET__8$kbA5oS__"